let milSymbolModule: Awaited<typeof import('milsymbol')> | null = null;
let milSymbolPromise: Promise<Awaited<typeof import('milsymbol')>> | null = null;

export function preloadMilsymbol(): Promise<Awaited<typeof import('milsymbol')>> {
  if (milSymbolModule) {
    return Promise.resolve(milSymbolModule);
  }

  if (!milSymbolPromise) {
    milSymbolPromise = import('milsymbol')
      .then((module) => {
        milSymbolModule = module;
        return module;
      })
      .catch((error) => {
        milSymbolPromise = null;
        throw error;
      });
  }
  return milSymbolPromise;
}
